import { createAction } from 'redux-actions';

export const resetROItemView = createAction('RESET_RO_ITEM_VIEW');
